import type {
  ProductAnnouncementDataWithBanner,
  ProductAnnouncementModalModalCta,
} from '@github-ui/product-announcement-shared/components/ProductAnnouncement.types'

import type {PromotionalBannerPayload} from '../promotional-banner/PromotionalBanner'
import {safeHref} from '../promotional-banner/safe-href'

function navigationCta(cta?: ProductAnnouncementModalModalCta): ProductAnnouncementModalModalCta | undefined {
  if (
    !cta?.label ||
    !cta.href?.trim() ||
    !safeHref(cta.href) ||
    !cta.analyticsAction ||
    cta.analyticsAction.length > 100 ||
    !/^[a-z][a-z0-9_-]*$/.test(cta.analyticsAction)
  ) {
    return undefined
  }
  // CTA navigation must never take the announcement's dismiss-and-redirect path.
  if (new URL(cta.href, 'https://github.com').pathname === '/in-product-messaging/dismiss-and-redirect')
    return undefined
  return cta
}

export function announcementData(
  announcement: PromotionalBannerPayload['announcement'],
): ProductAnnouncementDataWithBanner | undefined {
  if (announcement?.version !== 1) return undefined
  const data = announcement.data
  if (!data?.banner?.title || !data.banner.label || !data.modal?.title || !Array.isArray(data.modal.tabs))
    return undefined

  const tabs = data.modal.tabs.flatMap(tab => {
    if (!tab?.title || !tab.heading || !tab.description || !tab.visual) return []
    const cta1 = navigationCta(tab.cta1)
    const cta2 = navigationCta(tab.cta2)
    if (!cta1 && !cta2) return []
    return [{...tab, cta1, cta2, dropdown: undefined}]
  })
  if (tabs.length === 0) return undefined

  return {
    banner: {
      ...data.banner,
      variant: data.banner.variant ?? 'nudge',
      webGLSceneId: undefined,
      domAnimationSceneId: undefined,
    },
    modal: {
      ...data.modal,
      tabs,
      shouldAnimateTitle: false,
      cta1: undefined,
      cta2: undefined,
      dropdown: undefined,
      seeAll: undefined,
    },
  }
}
